import React, {useReducer, useRef} from 'react';
import {connect} from "react-redux";
//import PropTypes from "prop-types";
// import {numToLetter} from "../../../../../helpers/sqftHelper";
import {iconHeight, iconLength, iconLink, iconThickness} from "../../../../../assetsSQFT";
import sqftConfig from "../../../../canvas/store/sqftConfig";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import {is3DMode} from "../../../NavigationHelper";

const MIN_VALUE = 1;
const MAX_VALUE = sqftConfig.measureUnit === "Metric" ? 15000 : 700;

const CustomSizeList = (props) => {
  const {isEnabled, shape} = props;
  const [, forceUpdate] = useReducer(x => x + 1, 0);

  const widthRef = useRef(shape.getWidth());
  const heightRef = useRef(shape.getHeight());
  const depthRef = useRef(shape.getDepth());

  let shapeDepth = shape.getDepth();
  let shapeWidth = shape.getWidth();
  let shapeHeight = shape.getHeight();

  const changeWidth = (value) => {
    const val = parseFloat(value);
    if (!isNaN(val) && val >= 1 && val <= MAX_VALUE) {
      shape.setWidth(val);
      widthRef.current = val;
    } else {
      shape.setWidth(widthRef.current);
    }
    forceUpdate();
  };

  const changeHeight = (value) => {
    const val = parseFloat(value);
    if (!isNaN(val) && val >= 1 && val <= MAX_VALUE) {
      shape.setHeight(val);
      heightRef.current = val;
    } else {
      shape.setHeight(heightRef.current);
    }
    forceUpdate();
  };

  const changeDepth = (value) => {
    const val = parseFloat(value);
    if (!isNaN(val) && val >= 1 && val <= MAX_VALUE) {
      shape.setDepth(val);
      depthRef.current = val;
    } else {
      shape.setDepth(depthRef.current);
    }
    forceUpdate();
  };

  return (
    <div className={( isEnabled ? "" : " segment-container--disabled")}>
      <ul className={"mitered-segment segment-params"}>
        <li className="mitered-segment__content segment-height">
          {/*<div className="segment-letter">{numToLetter(index + 1)}</div>*/}
          <div className="segment-image">
            <img src={iconHeight} alt=""/>
          </div>
          <div className="segment-value">
            <input className="ui-input segment-value-input"
                   type="number"
                   min={MIN_VALUE}
                   max={MAX_VALUE}
                   onChange={(e) => changeHeight(e.target.value)}
                   placeholder={shapeHeight}
                   value={shapeHeight} />
          </div>
          <div className="segment-description">
            <div>
              <img src={iconLink} alt=""/>
            </div>
            <div>
              <FormattedMessage id={"sqft.navigation.mitered.height"}/>
            </div>
          </div>
        </li>
        <li className="mitered-segment__content segment-length">
          <div className="segment-image">
            <img src={iconLength} alt=""/>
          </div>
          <div className="segment-value">
            <input type="number"
                   min={MIN_VALUE}
                   max={MAX_VALUE}
                   className="ui-input segment-value-input"
                   placeholder={shapeWidth}
                   value={shapeWidth}
                   disabled={is3DMode()}
                   onChange={(e) => changeWidth(e.target.value)} />
          </div>
          <div className="segment-description">
            <FormattedMessage id={"sqft.manual.column.width"}/>
          </div>
        </li>
        <li className="mitered-segment__content segment-thickness">
          <div className="segment-image">
            <img src={iconThickness} alt=""/>
          </div>
          <div className="segment-value">
            <input type="number"
                   min={MIN_VALUE}
                   max={MAX_VALUE}
                   className="ui-input segment-value-input"
                   placeholder={shapeDepth}
                   value={shapeDepth}
                   onChange={(e) => changeDepth(e.target.value)} />
          </div>
          <div className="segment-description">
            <FormattedMessage id={"sqft.navigation.waterfall.depth"}/>
          </div>
        </li>
      </ul>
    </div>
  );
};

CustomSizeList.propTypes = {
  isEnabled: PropTypes.bool,
  // navMiteredSection: PropTypes.shape(miteredSectionInterface)
};

const mapStateToProps = (store) => {
  return {
    menuOpened: store.sqftMenuState.menuOpened,
  };
};

const mapDispatchToProps = {
};


export default connect(mapStateToProps, mapDispatchToProps)(CustomSizeList);
